var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-tip flex jcc aic",class:[_vm.labelType],style:(_vm.borderRadiusType)},[_c('span',[_vm._v(_vm._s(_vm.text || _vm.autoText))])])}
var staticRenderFns = []

export { render, staticRenderFns }